import { Box } from "@mui/material";

export default function FormRow({ children, sx, ...props }) {
    return (
        <Box sx={{
            display: "flex",
            flexBasis: "100%",
            flexWrap: "wrap",
            gap: { xs: 1.5, sm: 2, lg: 2.5 },
            ...sx
        }} {...props}>
            {children}
        </Box>
    );
}
